import { render, staticRenderFns } from "./orderid.vue?vue&type=template&id=c679d9d0&"
import script from "./orderid.vue?vue&type=script&lang=js&"
export * from "./orderid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports